import axios from "axios"
import { API_KEY_HEADER, SERVICE_ROUTE_REQUESTS_PATH } from "./const"
import { MOCK_SERVER_BASE_API_URL } from "./env"
import type { MockServerRequestDto } from "./types"

function getRequestsUrl() {
  if (!MOCK_SERVER_BASE_API_URL) {
    throw new Error("VITE_MOCK_SERVER_BASE_API_URL is not set")
  }

  return new URL(SERVICE_ROUTE_REQUESTS_PATH, MOCK_SERVER_BASE_API_URL.replace(/\/+$/, "")).href
}

export async function fetchMockServerProjectRequests(
  apiKey: string
): Promise<MockServerRequestDto[]> {
  const response = await axios.get<MockServerRequestDto[]>(getRequestsUrl(), {
    headers: { [API_KEY_HEADER]: apiKey },
  })

  return response.data
}
